import React, { Component } from "react";
import * as LINK from "./../../constants/Links";

import { connect } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Route, Switch, Link, Redirect } from "react-router-dom";

import * as Actions from "./../../actions/index";

class Index extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {

    };

  }
  // static getDerivedStateFromProps(nextProps, prevState)
  // {


  // }

  componentDidUpdate(prevProps, prevState)
  {


  }
  componentDidMount()
  {

  }
  render()
  {
    let { routers } = this.props;

    return (
      <div className="mt-5 p-6 container">
        <div className="ant-card ant-card-bordered">
          <div className="ant-card-head">
            <div className="ant-card-head-wrapper">
              <div className="ant-card-head-title">Create your lock</div>
            </div>
          </div>
          <div className="ant-card-body">
            <div data-show="true" className="ant-alert ant-alert-success ant-alert-no-icon" role="alert" style={{ marginBottom: "24px" }}>
              <div className="ant-alert-content">
                <div className="ant-alert-message">
                  <div>
                    <h5 className="ant-typography">PinkLock is audited by: </h5>
                    <div className="AuditTable_root__G2b28">
                      <div className="AuditTable_item__BI-jX" style={{ background: "rgb(23, 25, 33)" }}>
                        <a href="https://leaderboard.certik.io/projects/pinksale" rel="nofollow noreferrer" target="_blank"><img src="/static/media/ic-certik.8773a6f7.svg" alt="Certik" /></a>
                      </div>
                      <div className="AuditTable_item__BI-jX" style={{ background: "rgb(0, 44, 140)" }}>
                        <a href="https://github.com/solidproof/projects/blob/main/Pinksale/SmartContract_Audit_Solidproof_PinkSale.pdf" rel="nofollow noreferrer" target="_blank"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMkAAAAyCAYAAAD2k//fAAAACXBIWXMAAAsSAAALEgHS3X78AAANM0lEQVR4nO1dW2xcRxn+4thtGlq8KQ6F0tYnFAK0Ct42AiR48AZxlVDrvFHxkE0R4gGpdhEST1Ud8UAfoHWEhBAP2OESEOVhGwQUFZqzQsADpayBAqEpWfeSS9Mku03jxHGbg0Z8I/0ZZs6Zc3br3YX5pKPdPZc5t/+b/zqz65IkQZdRAlAGEHe74YCAXmCoy+esAGjy8xUAPwDwsfBmAwYZ3SKJ0h5zAA4CGAUQAXgRwFsBPADgO/weEDBw6Ia5VSVBRvl7CcAUgBsB7OTnCgB1op8AeBTAiSAqAYOCoiQpkQizAMbF+kdImhZ/K+LcB+CTAJ4CsMp1PwfwOwCNICkB/Y68JFEO+QwJMirWt7l+gb+/BOAvAH7J39sBTALYCmAEwClql5cAHCNZlrguIKCvkEWSEp3wKX6OG9vbNLXmqD1KJMpGAK8CeALA1wC8zP3fS8JsFSbYBW6/BOBfNMVadPxfZjsBAT2DIklERxskgv6MLKTQWCQxasK0miJBlIapA7gKwEkANwG4F8CvxfGbAWwD8AES6wUAVwBYBnCGn6dIQtX+ekbNAgLWHIokyq+43+PEdZKiZghshb7JpLGvJsmtAM4x8nWAvsg5o22lWcYAvJkkUcS5COAso2TDJE1w+APWHMPGCevie0wyNC2JQe24Vw1yaFwQGqFB02odgDsAfALAb9juIQDnAfyTi4Qi2ZUAruayLohHQC9gkqSScg1lblfLnRnXugHAJqFJnqLptEKCfZC+iRL835JUh+mXnOd+5/j9qiAZAb3EsCBGW1zHLD/LFGqbtvDB27iP8m9OU7NcR+FfT01xEz+3c/shOutSq62jkx8QsOaQmkTmLHx8lDRcpCZYZZh3hcRQhDtOMuh1F0iYV/lbaZPXRNur3P+i57kjEXjQaPH+8tSTRewkysb6Bpd+CyTYrIBmCHgUhn7vDdPc6iZ0GHdUCP2I+K6E/yj3O0eSXKRG2yiu40qaXK9kXFuFEbeJlH3aDDzMiKicrZ0ZD5PyEZ7PRbzYoYF9fKsKAx0mdrDdiJHEtAikxCKPq3l2FK7zSyyRgDVei+t5DhqqIqWhltowe0Vfc6rOBxKn9FA60vUtOug2vAHADQwDRzSlriBZVozcyCUKVlq+RN3UtMf1K8LucmiIPO2AJFLLXpJqLRHlNIEnuEzzHc56ksVFaF3pHVGoZo1k8qBC3c88gN3yXoY9e4A2o1m+5sqqYTKZOEff4xDXqxf4UX6/lmFfX8zmEGwNW7QuztBCLkzz+GqBY3uBSWqJ3R0IdUs8wwVqnhqFbDbj2H6Geof7zOciq4BdPVObD8GXIBF7/0s5HsYiH/Iyl9Ni23oR6bKdq4j/ZArHQkGCaOyiFhokzHdRA8aUkfsNX3DQULZZSEMemmQmZyFiRD9iJOcDUiHg50gSSd7Nho9iXpsLdbHIyN2ScT/VDP9jkSbVPh7rwnRGCH0tseh5roe6eM0NPqNB1iQl28ohQ2BsO5m9bkk4aoll0RrpQQrpEe7/XQCPA/gpgE8DuN1yrqPMvMviyXVcbNEtm1+hcJvI6VR4zbsp5DVjX5cGaNNR1kWdVXYA9zr2Rx8IyB4+qzI/N/G+00jTTT9ioY86iq5h2FAvetjtIs2PuuVEczQv0rBCk0nVZD1JLfFGAE+z9GSMpSjK93hetHOEyUdtql0tSOiLtkPzLVgIUjUIqaFNTFs7mlQPWbZNkkj9EnZt8b71Yntv4/Q3zWdTBA1LtE0/x5Zw9DUWLM+qLDo2jUbO64t4T75taGKXRApBozlkXKS2JzsN5w0x634jhf7tbPtdIoOuzLEtxnGaXC/x9zD9keUc5x5NcaJbxr1NOfabyzAx51JML1ebvUaVYevX85ptcnNQaOOGkLGyIYwRO+jYsBD0qNemx3XqAMwRo+2SCOva2pjlEolaRL1UdJ6kzl5QX1wsekUTMx4hyBFqjhUS5Qy/X0+hHyFZ2pZjx0Qh4yi1iWucSdNxHfMiNJkWcHD5Ij5O+CzPY6LSx068K//TLROp4nineqiF1TEWFkyN+5pkmxEhZleouSxItsnRxpSwKGRHqu9fH3+Z2awd5Iaxs/49bnmALa7bQUfNhlVW7Z6mqXWC0amj/H6MOZQ/G8eOUYsc5e8LTCKedZwnzZ7Woc6GQ7O4/Jm6pyZ1ka+foztNhwb0SUj6wJUmmOY2G0FKFNo5Y1SriTnRAdlIvZBCMo2aGB/lrT01SfSNTfCipanh6hVj3tQWB1nUgKvHAPyM5fF1/n6cicHHLMfcAuBNQttcQ42zmnINLhNCY4I9ftOigm3w9Sdc+3USSl4LuK7b1Wn4IhLZahP7Us47w20+QY8G2zc7x2qOXFWD5/TW9iZJIKYF0j3OBC8qTaiqnPRBq1ol4L8C8E2GT38EYD8f1n5OCGHzM1QC8q8kxTX83U7RJOC5fUKe49QsWQ8yj9NtC2z0O1y9rOv9+iASY41smiTN6c4lsCRTySD1TM7IoiaZlzbRJGmJHlkfKG9sFxmYZrvWOnAAN/AcY6IUImL5yvqMY1t8YHs9zzXfRRt8EBNnLjIUCdaURZAjzgiYuI5HgcialLWIHXknbaRiyDgI4kBTpY0bNr7tYcfUFispJpKJWzm+pM2Q8DPcfolml+9oxBlh+tmcR4k0XyaP4Nts+bSEYz/DFs2z5cHkEosBeEWy9+WCM+bIDjuiJZGX5LHvu7aRRIdQG44XLm18W89RY8Y9K2yrtMbdAD5ColzPKNhFbhujhsmq/pVoiqTf7hSBHee4Fht8bXPXfv1cmu4aG+TqVHQi17VoP6DolLZFc0qSWFFBLdgqQpKWcMC18KfZiqMkiyksMceMmEm62zkZxAFm4z/LzPhrIiT8D+77PuZI8hQ6SugkWjnFX3HNKDnh+fBcpkU/zyXmMi96OW9zp51KJyavV1TPnOZUmyE6R7LgYT6YZleLGsEM7yYM7T5Jc2yZPdhpmmZPcL9raWad9jCbstBKcehKKZGxLEcyLZLSrxOFl1LuqxvZ9qLo1D/s5Hl7BV5MksSi550VKmmPQ2BtJSC24cAay8ybPMuSlSbzIoqIf+c+G+mPnPKYc6tsCe2aSIvauITjzowoWC2lnKWXAueCzmb32zXHBaNqFUelSB54H2ObMFv3NrtEQzrstpOE2cNCP5s9OOWYvEHZsO9gLuRmAO+kaXMdfY8XWbayleuOWtowMSUCCrEloDCVkedJ05TzYoyERiVjkFq/ZdorvMcjKfmbuS6UIRVFU+Tm8kA6/DFlIC9R/Id/qBkcLUuc/AexY7triZIkaSVJ8lXL9q1JkjyYJMnnkiS5J0mSu5IkmU6SZEeSJBu4zx1Jknw4SZLtnudrJMXQEm1MFWzDRNO4tjjf4ZehkrIeKdvzouF4rrr9PO/etcjrdr3D2ZwylvBTr6vlbKNEGShb3tl/teP66wVtx0/mGHFXEmaIrax9IxOEoxwjMspjjrH85BZqkxcs/owNUQfZbdnj11LKa3zR7uPCRhfaXcwXdQI99NdXm8xZMvhzoqbQt42Gb5DFRRJZ7jHncQPaDNFCe5Nln2Vmztucj6vNnIiOaG0Ts6b45FiKvuC6xZmvdkCUtLL6fsViB6HTbqMmCguz5EyPVzFzMrGo3cpqoyomVvRC2p/4zFAARo3kmx7IVBUlzAct4TRVkvIVlqGoSbM/TxJt4Xk/BOD79F8+zokhIJKJWYgLlIXsTenxq/Sz8kTU6h0kxHqBNu+x3Gezm1QpR65iVO0/aNmzXbsuxW86kt1lUUhpOv6pSCNJUzBWRnv0dDPzrO60xZqfFSHe4/x9hsf9jREu3ZtvofZ4hrM5+qJpVCO7HPA2t+/ImEoIfIA6mufKr8j2cj3sLqKVg8xLvN6dGWHgXkKP89CmVyK0S0tom6wOqcplhvLWEG3EIlqbq1Pz+X+SGkkizQrXKDeNB6iBVBj33STGDZw26E8A/sheWM3a+Bb6JEskT6e4bFRZF4RYttfI0QOXOygabDgy+rbzm8V+GoM8MZ28p6L3IdtodaLtfUiiS+fHSZRIZLRdRFlgmcky/5PkYYZ9VaLwLhHu/QKAP7DdA0VvIiDg9YTPH4tqVaj9k1hknF3O7nnWXJ2gdjjJf776DAmymdrpMEvqA0EC+ha+/74rHaoJD6KcZALrMGeUV+ryh/RP1EQQ7yeJnqapFRDQt8j7n4lVMa57UUQaqsZ4b2lujdDEOsuM+93UJttY5BgQ0NfI+z/uCyxBh9AouhDyNhFhOs5o1bcBfIoEUVW3X+f25wNBAgYFRf+iWmoOOU9wieG35+iQ68z5pKjJ2k/SnAxSEjAIKEoSWEysPY6y9PtY9j7CTPwXg2QEDBI6IQnEbOK6BLsusqcqi/4Nlpo8zCrgLwfpCBg0dEoSiJkyZLHhPRxZeDOLHb/HJGJAwMAhr+NuQ9MyW8l7aFopAv0iECRgkNENTSKhB/moCeh+D+DHXRiCGxDQU3SbJBql/6H/0Av4fwaAfwMVJVMhC4e9gwAAAABJRU5ErkJggg=="
                          alt="SolidProof" /></a>
                      </div>
                      <div className="AuditTable_item__BI-jX">
                        <a href="https://github.com/interfinetwork/smart-contract-audits/blob/audit-updates/PinkLockV2_AuditReport_InterFi.pdf" rel="nofollow noreferrer" target="_blank"><img src="/static/media/ic-interfi.550ac754.png" alt="Interfi" /></a>
                      </div>
                      <div className="AuditTable_item__BI-jX">
                        <a href="https://github.com/ContractChecker/audits/blob/main/PinkLock Security Audit Report - By ContractChecker.pdf" rel="nofollow noreferrer" target="_blank"><img src="/static/media/ic-contractchecker.0ee10bea.png" alt="ContractChecker" /></a>
                      </div>
                      <div className="AuditTable_item__BI-jX" style={{ background: "rgb(255, 255, 255)" }}>
                        <a href="https://github.com/CFG-NINJA/audits/blob/main/20220613_CFGNINJA_PinklockV02_Audit.pdf" rel="nofollow noreferrer" target="_blank"><img src="/static/media/ic-cfgninja.25905e3a.png" alt="CFGNinja" /></a>
                      </div>
                      <div className="AuditTable_item__BI-jX">
                        <a href="https://github.com/cyberscope-io/audits/blob/main/pinksale/pinksale-locker-v3.pdf" rel="nofollow noreferrer" target="_blank"><img src="/static/media/ic-cyberscope.229dcaae.png" alt="CyberScope" /></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ant-alert-description"></div>
              </div>
            </div>
            <div className="ant-spin-nested-loading">
              <div className="ant-spin-container">
                <form>
                  <input type="hidden" value="0" /><input type="hidden" value="" />
                  <div className="field"><label className="label" for="address">
                    <div className="is-flex is-align-items-center mb-2 flex-wrap">
                      <div className="is-flex-grow-1 mr-4"><label className="label"
                        for="address">Token or LP Token address<sup
                          className="has-text-danger">*</sup></label></div>
                    </div>
                  </label>
                    <div className="control"><input className="input" type="text" placeholder="Enter token or LP token address" id="address" name="address" autocomplete="on" value="" /></div>
                  </div>
                  <div className="field"><label className="ant-checkbox-wrapper"><span
                    className="ant-checkbox"><input name="useOwner" id="useOwner"
                      type="checkbox" className="ant-checkbox-input" value="" /><span
                        className="ant-checkbox-inner"></span></span><span>use another
                          owner?</span></label></div>
                  <div className="field"><label className="label" for="title">Title</label>
                    <div className="control"><input className="input" type="text" placeholder="Ex: My Lock" id="title" name="title" autocomplete="on" value="" /></div>
                  </div>
                  <div className="field"><label className="label" for="amount">Amount<sup
                    className="has-text-danger">*</sup></label>
                    <div className="control"><input className="input" type="text" placeholder="Enter amount" id="amount" name="amount" autocomplete="on" value="" />
                      <div className="FormField_max__311XR">MAX</div>
                    </div>
                  </div>
                  <div className="field"><label className="ant-checkbox-wrapper"><span
                    className="ant-checkbox"><input name="useVesting" type="checkbox"
                      className="ant-checkbox-input" value="false" /><span
                        className="ant-checkbox-inner"></span></span><span>use
                          vesting?</span></label></div>
                  <div className="field"><label className="label" for="endTime">Lock until (UTC
                    time)<sup className="has-text-danger">*</sup></label>
                    <div className="control">
                      <div className="ant-picker ant-picker-middle" style={{ width: "100%" }}>
                        <div className="ant-picker-input"><input id="lockTime" readonly="" placeholder="Select date" title="" size="20" autocomplete="off" value="" /><span className="ant-picker-suffix"><span role="img"
                          aria-label="calendar"
                          className="anticon anticon-calendar"><svg
                            viewBox="64 64 896 896" focusable="false"
                            data-icon="calendar" width="1em" height="1em"
                            fill="currentColor" aria-hidden="true">
                            <path
                              d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z">
                            </path>
                          </svg></span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div data-show="true" className="ant-alert ant-alert-warning ant-alert-no-icon" role="alert">
                      <div className="ant-alert-content">
                        <div className="ant-alert-message">
                          <article className="ant-typography">Please exclude PinkLock's lockup address <span className="ant-typography">
                            <strong>0x407993575c91ce7643a4d4cCACc9A98c36eE1BBE</strong>
                            <div role="button" tabindex="0"
                              className="ant-typography-copy" aria-label="Copy"
                              style={{ border: "0px", background: "transparent", padding: "0px", lineHeight: "inherit", display: "inline-block" }}>
                              <span role="img" aria-label="copy"
                                className="anticon anticon-copy"><svg
                                  viewBox="64 64 896 896"
                                  focusable="false" data-icon="copy"
                                  width="1em" height="1em"
                                  fill="currentColor" aria-hidden="true">
                                  <path
                                    d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z">
                                  </path>
                                </svg></span>
                            </div>
                          </span> from fees, rewards, max tx amount to start locking tokens.<br />We don't support rebase tokens.
                          </article>
                        </div>
                        <div className="ant-alert-description"></div>
                      </div>
                    </div>
                  </div>
                  <div className="has-text-centered">
                    <div className="has-text-info mb-2"></div><button type="submit" className="ant-btn ant-btn-primary" disabled=""><span>Lock</span></button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>


    );
  }
}
const mapStateToProps = (state) =>
{
  return {

  };
};
const mapDispatchToProps = (dispatch, props) =>
{
  return {
    // GetConvertion: (idpage) =>
    // {
    //   dispatch(Actions.GetConvertionRequest(idpage));
    // },
    // Getprovince: () =>
    // {
    //   dispatch(Actions.GetprovinceRequest());
    // },
    // GetComment: (idpage) =>
    // {
    //   dispatch(Actions.GetCommentRequest(idpage));
    // },
    // GetPageList: (data) =>
    // {
    //   dispatch(Actions.GetPageListRequest(data));
    // },
    // SetPageLocal: (data) =>
    // {
    //   dispatch(Actions.SetPageLocal(data));
    // },
    // GetSetting: () =>
    // {
    //   dispatch(Actions.GetSettingRequest());
    // },
    // GetSuportReply: () =>
    // {
    //   dispatch(Actions.GetSuportReplyRequest());
    // },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
